import React from "react";

const Map = () => {
  return (
    <div className="google-map mb-1">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d269.76459816640283!2d81.29485584009012!3d24.53719341395233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39845bf23f992ad7%3A0x341f99450870db99!2sWind%20group%20rewa!5e0!3m2!1sen!2sin!4v1747657509347!5m2!1sen!2sin"
        width="100%"
        height="100%"
        // style="border:0;"
        // allowfullscreen=""
        // loading="lazy"
        // referrerpolicy="no-referrer-when-downgrade"
        frameBorder={0}
        allowFullScreen
        aria-hidden="false"
        tabIndex={0}
      />
    </div>
  );
};

export default Map;
